import { createContext, PropsWithChildren, useEffect, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { setUser, userSelector } from '@/core/store/user/userSlice';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { postIntroBannerShown } from '@/core/api';
import logger from '@/core/logger';
import IntroBannerModal from '@/components/IntroBannerModal/IntroBannerModal';

export const IntroBannerContext = createContext<{
  isModalOpened: boolean;
  closeModal: () => void;
}>({
  isModalOpened: false,
  closeModal: () => {},
});

export function IntroBannerProvider({ children }: PropsWithChildren) {
  const dispatch = useAppDispatch();
  const user = useAppSelector(userSelector);
  const { vs9133IntroBanner } = useFlags();

  const [isModalOpened, setIsModalOpened] = useState(false);

  const shouldShow =
    !!user && !!vs9133IntroBanner && user.IntroBannerShown === false;

  useEffect(() => {
    if (shouldShow) {
      setIsModalOpened(true);
    }
  }, [shouldShow]);

  const closeModal = () => {
    if (user) {
      dispatch(setUser({ ...user, IntroBannerShown: true }));
    }
    setIsModalOpened(false);
    postIntroBannerShown().catch((err) =>
      logger.error('Failed to mark intro banner as shown', err)
    );
  };

  return (
    <IntroBannerContext.Provider value={{ isModalOpened, closeModal }}>
      {children}
      <IntroBannerModal isModalOpened={isModalOpened} closeModal={closeModal} />
    </IntroBannerContext.Provider>
  );
}
